export const DsfNavMenuSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_homepage" */ "./navMenuSetting"));